/**
 * Dashboard
 * @namespace gplans.dashboard.services
 */
(function () {
  'use strict';
  angular.
  module('gplans.dashboard.services').
  factory('ValidateBodyfat', ValidateBodyfat);

  ValidateBodyfat.$inject = ['$rootScope', 'MeasurementSystem', 'UserService'];ValidateBodyfat.$inject = ["$rootScope", "MeasurementSystem", "UserService"];

  function ValidateBodyfat($rootScope, MeasurementSystem, UserService) {

    var ValidateBodyfat = {
      validate: validate };


    return ValidateBodyfat;

    function validate(waist, hips, height, mes_system) {
      if (mes_system === 'SI') {
        waist = MeasurementSystem.convertCmToInch(waist);
        hips = MeasurementSystem.convertCmToInch(hips);
      }
      var hip_subtractor = UserService.data.gender == 'male' ? 2 : 1;
      var waist_subtractor = UserService.data.gender == 'male' ? 4 : 2;
      var a = hips * 1.4 - hip_subtractor;
      var b = waist * 0.72 - waist_subtractor;
      var c = a + b;
      var d = height * 0.61;
      var perc = c - d - 10;
      if (UserService.data.gender == 'male' && perc < 0 || UserService.data.gender == 'female' && perc < 2) {
        alert('Wrong hips or waist');
        return false;
      }
      return true;
    }
  }
})();